module.exports = __webpack_public_path__ + "img/icon-pdf.9a857520.png";